import { Link } from "react-router-dom";
import { AlertTriangle, MapPin, MessageSquare, ChevronRight, Repeat } from "lucide-react";
import { TradeBadge, StatusBadge } from "./Badges";
import { eur, fdate } from "@/lib/hz";

export const JobRow = ({ job, role }) => (
  <Link to={`/trabajos/${job.id}`} data-testid={`job-row-${job.id}`}
    className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 transition-colors hover:border-orange-300">
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <TradeBadge trade={job.trade} />
        <StatusBadge status={job.status} />
        {job.urgency === "urgente" && <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2 py-0.5 text-xs font-semibold text-rose-700"><AlertTriangle className="size-3" />Urgente</span>}
        {job.recurrence_id && <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600"><Repeat className="size-3" />Periódico</span>}
        {job.unread > 0 && <span className="inline-flex items-center gap-1 rounded-full bg-orange-600 px-2 py-0.5 text-xs font-semibold text-white"><MessageSquare className="size-3" />{job.unread}</span>}
      </div>
      <div className="mt-2 truncate font-heading text-lg font-bold text-slate-900">{job.title}</div>
      <div className="mt-1 flex flex-wrap gap-x-4 text-sm text-slate-500">
        <span className="flex items-center gap-1"><MapPin className="size-3.5" />{job.city}</span>
        <span>{fdate(job.created_at)}</span>
        {role === "cliente" && job.status === "abierto" && <span className="font-semibold text-sky-700">{job.quotes_count} presupuestos</span>}
        {role === "profesional" && <span>Cliente: {job.client_name}</span>}
        {role === "cliente" && job.pro_name && <span>Profesional: {job.pro_name}</span>}
      </div>
    </div>
    <div className="text-right">
      <div className="font-heading text-lg font-extrabold">{eur(job.price ?? job.budget)}</div>
      <div className="text-xs text-slate-500">{job.price != null ? "precio" : job.budget != null ? "presupuesto máx." : ""}</div>
    </div>
    <ChevronRight className="size-5 text-slate-300" />
  </Link>
);
